// Helper functions put here
import React, { useState, useEffect } from "react";
import axios from "../utils/axios_interceptor"
import Cookies from "universal-cookie";
import DeliveryCycleInfo from "../components/variantDrawerDeliveryCycleInfo/variantDrawerDeliveryCycleInfo";
import {
  MARKUP_ACTIVITY_INFO,
  MARKUP_PURCHASE_LIST,
  MARKUP_MAX_QUANTITY_PURCHASE,
  MARKUP_PRODUCT_ITEMCODE,
  MARKUP_ADMIN_PURCHASSE_QUANTITY,
  USER_ALL_PROMOTIONS_LIST,
  SOP_ORDER_LIST_SELECTED,
  SOP_ORDER_SIGNID_LIST,
  PROMOTION_LOTTERY_SWITCH,
  PROMOTION_OERERS_LOTTERY_LIST,
  PROMOTION_WINNING_PROMOTION_LOTTERY_LIST,
  PROMOTION_LOTTERY_REFRESH_LOCK,
  SHOW_SOP_ORDER_REMINDER,
  VISITORS_PROMOTIONAL_DETAILS,
  VISITORS_CART_PURCHASE_ITEM_CODE_LISTS,
  VISITOR_POP_UP,
  SHARE_VISITORS_CONNECTION_INFO,
  VISITORS_FORBID_PRODUCT_LABELS_ALREADY_REMOVED,
  VISITORS_FORBID_PRODUCT_SOP_ALREADY_REMOVED,
  CONSIGNEE_GUEST_FLAG,
  VISITORS_FIRST_SHOPPING,
  VISITORS_BINED_PHONE_NUMBER,
  VISITORS_CONTENT_STACK_DATA,
  VISITORS_UP_LEVEL_NUMBER,
  UTM_PARAMS
} from "../utils/Constants/Constants"

export const getPdmApiUrl = () =>
  (typeof window === "undefined" ? process.env : window.appConfig || {})
    .PDM_BFF_API || "http://localhost:3002";

export const getPurchaseApiUrl = () =>
  (typeof window === "undefined" ? process.env : window.appConfig || {})
    .PURCHASE_BFF_API || "http://localhost:3002";

export const getAcApiUrl = () =>
  (typeof window === "undefined" ? process.env : window.appConfig || {})
    .CI_BFF_API || window.location.origin.replace(window.location.port, "3003");

export const getUserLandingPage = () =>
  (typeof window === "undefined" ? process.env : window.appConfig || {})
    .LOGIN_LANDING_PAGE || "/profile";

export const getJwtSignedUrl = () =>
  (typeof window === "undefined" ? process.env : window.appConfig || {})
    .JWT_SIGNED_URL;

export const getEnv = () =>
  (typeof window === "undefined" ? process.env : window.appConfig || {})
    .LOGIN_SDK_ENV || "qa";

export const getRouter = () => {
  if (typeof window === "undefined") return {};
  return window.useRouter && window.useRouter();
};

export const getParams = () => {
  if (typeof window === "undefined") return {};
  return window.useParams
    ? window.useLocation
      ? {
        ...window.useParams(),
        ...getQueryStringParams(window.useLocation().search),
      }
      : window.useParams()
    : {};
};

export const getQueryStringParams = (query) => {
  return query
    ? (/^[?#]/.test(query) ? query.slice(1) : query)
      ?.split("&")
      .reduce((params, param) => {
        let [key, value] = param?.split("=");
        params[key] = value
          ? decodeURIComponent(value.replace(/\+/g, " "))
          : "";
        return params;
      }, {})
    : {};
};

export const getCurrentPath = () => {
  const router = getRouter();
  let path = "";
  if (router && router.asPath) path = router.asPath;
  else if (router && router.location && router.location.pathname)
    path = router.location.pathname;
  return path;
};

export const isMobile = () => {
  if (typeof window !== "undefined") {
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      return true;
    } else {
      return false;
    }
  } else return false;
};

/**
 * 空值校验
 */
export const isEmpty = (obj) => {
  if (obj == null || obj == "undefined" || obj == "") {
    return true;
  } else {
    return false;
  }
};

export const formatNumber = (number, decimal, prefix, postfix) => {
  if (isNaN(number)) number = 0;
  number = parseFloat(number);
  if (!prefix) prefix = "";
  if (!postfix) postfix = "";
  return (
    prefix +
    number.toLocaleString(undefined, {
      minimumFractionDigits: decimal,
      maximumFractionDigits: decimal,
    }) +
    postfix
  );
};

export const formatNumber2 = (number, digit) => {
  if (isNaN(number)) number = 0;
  let digitStr = "";
  for (let i = 1; i < digit; i++) {
    digitStr = digitStr + "0";
  }
  var formattedNumber = (digitStr + number).slice(-digit);
  return formattedNumber;
};

export const formatDate = (dateString) => {
  let date = new Date(dateString);
  let year = date.getFullYear();
  let month = formatNumber2(parseInt(date.getMonth()) + 1, 2);
  let day = formatNumber2(date.getDate(), 2);
  return `${year}/${month}/${day}`;
};

//检测window屏幕变化
export const resizeWindow = () => {
  window.addEventListener("resize", function () {
    const width = window.innerWidth;
    return width;
  });
};

export const getLocalStorage = (key) => {
  if (typeof window !== "undefined") {
    let itemReturn = localStorage.getItem(key);
    if (!itemReturn) return {};
    if (itemReturn.substring(0, 1) === "{") return JSON.parse(itemReturn);
    return itemReturn;
  }
  return {};
};

export const deviceOSDetails = () => {
  const deviceInfo = navigator.userAgent;
  var operatingSys = "";
  if (deviceInfo.includes("iPhone") || deviceInfo.includes("iPad")) {
    operatingSys = "iOS";
  } else if (deviceInfo.includes("Macintosh")) {
    operatingSys = "MacOS";
  } else if (deviceInfo.includes("Windows")) {
    operatingSys = "Windows";
  } else if (deviceInfo.includes("Android")) {
    operatingSys = "Android";
  } else {
    operatingSys = "Linux/Unix";
  }

  return operatingSys;
};

export const formatAddress = (address = "", city = "", district = "") => {
  const formattedAddress = `${city ? ` ${city}` : ""}${district ? ` ${district}` : ""
    }${address ? ` ${address}` : ""}`.trim();

  return formattedAddress;
};

export const addToCart = async (
  itemCode,
  quantity = 1,
  additionalData = {}
) => {
  const apiUrl = getPdmApiUrl();

  const getConsigneeData = () => {
    if (typeof window === "undefined") return {};
    const onBehalfData = JSON.parse(localStorage.getItem("onbehalf"));

    if (!onBehalfData) return {};
    return {
      consigneeAda: onBehalfData.ada,
      consigneeType: onBehalfData.loginType,
      consigneeMemberType: onBehalfData.loginMemberType,
    };
  };

  const res = await axios.post(
    `/add-to-cart`,
    {
      itemCode,
      quantity: quantity,
      ...additionalData,
      ...getConsigneeData(),
    },
    {
      baseURL: apiUrl,
    }
  );
  return res;
};

export const useParamas = () => {
  const [params, setParams] = useState({});
  if (typeof window === "undefined") return {};
  const routeParams = window.useParams?.() || {};
  const { search } = window.useLocation?.() || {};
  useEffect(() => {
    setParams({
      ...routeParams,
      ...getQueryStringParams(search),
    });
  }, [routeParams, search]);
  return { params };
};

export const getLoggedInUserInfo = () => {
  if (typeof window === "undefined") return {};

  const cookie = new Cookies();

  const role = cookie.get("role") || "Guest";
  const vAda = cookie.get("vAda");
  const loginAda = cookie.get("ada") || "";
  const accessToken = cookie.get("accessToken") || "";
  const loginType = cookie.get("loginType") || "";

  return { role, loginAda, accessToken, loginType, vAda };
};

const deliveryDescriptionArray = [
  "單月配送意指以一個月為配送週期，配送當月份量之產品",
  "雙月配送意指以兩個月為配送週期，配送兩個月之份量產品",
];

const enumeration = {
  1: ['', '單月配送意指以一個月為配送週期，配送當月份量之產品'],
  2: ['', '隔月配送意指以兩個月為配送週期，配送一個月份量之產品', '雙月配送意指以兩個月為配送週期，配送兩個月之份量產品']
}
const bindFilterateProduct = (product) => {
  if (!product) return deliveryDescriptionArray
  const { sop_delivery_frequency_period, sop_frequency_switch } = product?.info;
  if (sop_delivery_frequency_period && sop_delivery_frequency_period?.value && sop_frequency_switch && (sop_frequency_switch?.value == "Open" || sop_frequency_switch?.value == "open")) {
    const deliveryFrequencyPeriod = JSON.parse(sop_delivery_frequency_period?.value);
    let deliveryIntroductionArray = []
    for (let index in deliveryFrequencyPeriod) {
      deliveryFrequencyPeriod[index].map((item) => {
        deliveryIntroductionArray.push(enumeration[index][item.period])
      })
    }
    return deliveryIntroductionArray
  } else {
    return deliveryDescriptionArray
  }
}
export const renderDeliveryInfo = (product) => (
  <DeliveryCycleInfo deliveryDescriptionArray={bindFilterateProduct(product)} />
);
// Object for product status
const productStatusObj = {
  buyAhead: {
    label: "預售",
    colorCode: "#D91734",
    actionType: "AddToCart",
    isActionEnabled: true,
  },
  upcoming: {
    label: "尚未上市",
    colorCode: "#D91734",
    actionType: "AddToCart",
    isActionEnabled: false,
  },
  outOfStock: {
    label: "暫停供貨",
    colorCode: "#D91734",
    // actionType: "NotifyMe",
    // isActionEnabled: true,
    actionType: "AddToCart",
    isActionEnabled: false,
  },
  notForSale: {
    label: "暫停供貨",
    colorCode: "#D91734",
    // actionType: "NotifyMe",
    // isActionEnabled: true,
    actionType: "AddToCart",
    isActionEnabled: false,
  },
};

export const getProductStatus = (product) => {
  const productStatus = product?.productStatus?.toLowerCase();
  if (productStatus === "buyahead") {
    return productStatusObj.buyAhead;
  } else if (productStatus === "upcoming") {
    return productStatusObj.upcoming;
  } else if (productStatus === "outofstock") {
    return productStatusObj.outOfStock;
  } else if (productStatus === "notforsale") {
    return productStatusObj.notForSale;
  }
};

export const isAddToCartDisabled = (productStatus) =>
  ["upcoming", "outOfStock", "notForSale"].includes(productStatus);

export const getNonStrictVariantsLS = () => {
  if (typeof window === "undefined") return {};
  return JSON.parse(localStorage.getItem("AMW_NON_STRICT_VARIANTS")) || {};
};

export const getMarkupPurchaseInfo = () => {
  if (typeof window === "undefined") return {};
  return JSON.parse(sessionStorage.getItem(MARKUP_PURCHASE_LIST)) || {};
}
export const setMarkupPurchaseInfo = (obj) => {
  if (typeof window === "undefined") return {};
  sessionStorage.setItem(MARKUP_PURCHASE_LIST, JSON.stringify(obj))
}

export const removeMarkupPurchaseInfo = () => {
  if (typeof window === "undefined") return {};
  sessionStorage.removeItem(MARKUP_PURCHASE_LIST)
}

export const getMarkupMaxQuantityInfo = () => {
  if (typeof window === "undefined") return {};
  return JSON.parse(sessionStorage.getItem(MARKUP_MAX_QUANTITY_PURCHASE)) || {};
}
export const setMarkupMaxQuantityInfo = (obj) => {
  if (typeof window === "undefined") return {};
  sessionStorage.setItem(MARKUP_MAX_QUANTITY_PURCHASE, JSON.stringify(obj))
}
export const removeMarkupMaxQuantityInfo = () => {
  if (typeof window === "undefined") return {};
  sessionStorage.removeItem(MARKUP_MAX_QUANTITY_PURCHASE)
}

export const getMarkupPurchaseQuantity = () => {
  if (typeof window === "undefined") return {};
  return JSON.parse(sessionStorage.getItem(MARKUP_ADMIN_PURCHASSE_QUANTITY)) || null;
}

export const setMarkupPurchaseQuantity = (obj) => {
  if (typeof window === "undefined") return {};
  sessionStorage.setItem(MARKUP_ADMIN_PURCHASSE_QUANTITY, JSON.stringify(obj))
}


export const removeMarkupPurchaseInformation = (obj, key) => {
  if (typeof window === "undefined") return {};
  delete obj[key]
  if (obj && JSON.stringify(obj) !== "{}") {
    sessionStorage.setItem(MARKUP_PURCHASE_LIST, JSON.stringify(obj))
  } else {
    sessionStorage.removeItem(MARKUP_PURCHASE_LIST)
  }
}

export const clearMarkupPurchaseInfo = (obj, key) => {
  if (typeof window === "undefined") return {};
  sessionStorage.removeItem(MARKUP_PRODUCT_ITEMCODE)
  sessionStorage.removeItem(MARKUP_ADMIN_PURCHASSE_QUANTITY)
  sessionStorage.removeItem(MARKUP_PURCHASE_LIST)
  sessionStorage.removeItem(MARKUP_MAX_QUANTITY_PURCHASE)
}

export const setNonStrictVariantsLS = (nonStrictVariants) => {
  if (typeof window === "undefined") return;
  localStorage.setItem(
    "AMW_NON_STRICT_VARIANTS",
    JSON.stringify(nonStrictVariants)
  );
};

export const dealWithMarkupPDPCaching = (route) => {
  if (typeof window === "undefined") return {};
  if (route == '/pdm-pdp') {
    const itemCode = sessionStorage.getItem(MARKUP_PRODUCT_ITEMCODE)
    const defaultPurchase = getMarkupPurchaseQuantity()
    if (defaultPurchase && defaultPurchase?.itemCode !== itemCode) {
      clearMarkupPurchaseInfo()
    }
  }
}
//  清除加价购缓存
export const removeMarkupPurchaseCache = () => {
  if (typeof window === "undefined") return {};
  sessionStorage.removeItem(MARKUP_ACTIVITY_INFO)
  sessionStorage.removeItem(MARKUP_PURCHASE_LIST)
  sessionStorage.removeItem(MARKUP_MAX_QUANTITY_PURCHASE)
  sessionStorage.removeItem(MARKUP_PRODUCT_ITEMCODE)
  sessionStorage.removeItem(MARKUP_ADMIN_PURCHASSE_QUANTITY)
}


//  清除批量SOP操作缓存
export const removeBatchSopOperationCache = () => {
  if (typeof window === "undefined") return {};
  localStorage.removeItem(SOP_ORDER_LIST_SELECTED)
  localStorage.removeItem(SOP_ORDER_SIGNID_LIST)
}

//  清除用户认购促销缓存
export const removeUserAllPromotionsCache = () => {
  if (typeof window === "undefined") return {};
  localStorage.removeItem(USER_ALL_PROMOTIONS_LIST)
}
//  清除訂單抽獎緩存
export const removeOerersLotteryCache = () => {
  if (typeof window === "undefined") return {};
  localStorage.removeItem(PROMOTION_LOTTERY_SWITCH)
  localStorage.removeItem(PROMOTION_OERERS_LOTTERY_LIST)
  localStorage.removeItem(PROMOTION_WINNING_PROMOTION_LOTTERY_LIST)
  localStorage.removeItem(PROMOTION_LOTTERY_REFRESH_LOCK)
}
//  清除訪客購物流程緩存
export const removeVisitorShoppingCache = () => {
  if (typeof window === "undefined") return {};
  //  訪客連結長客計畫彈窗是否彈出過標識
  localStorage.removeItem(SHOW_SOP_ORDER_REMINDER)
  //  訪客限购促销超链接UI数据
  localStorage.removeItem(VISITORS_PROMOTIONAL_DETAILS)
  //  访客购物车商品 ItemCodeList
  localStorage.removeItem(VISITORS_CART_PURCHASE_ITEM_CODE_LISTS)
  //  訪客身份彈出窗信息
  localStorage.removeItem(VISITOR_POP_UP)
  //  已發送訪客連繫資訊至服務直銷商標識
  localStorage.removeItem(SHARE_VISITORS_CONNECTION_INFO)
  //  访客不可购标记
  localStorage.removeItem(VISITORS_FORBID_PRODUCT_LABELS_ALREADY_REMOVED)
  //  sop商品标记
  localStorage.removeItem(VISITORS_FORBID_PRODUCT_SOP_ALREADY_REMOVED)
  //  是否访客的标记
  localStorage.removeItem(CONSIGNEE_GUEST_FLAG)
  //  是否是第一次購貨
  localStorage.removeItem(VISITORS_FIRST_SHOPPING)
  //  登錄 FOA 手機號碼
  localStorage.removeItem(VISITORS_BINED_PHONE_NUMBER)
  //  LC登錄組件返回 是否彈出過個資告知彈出窗 標識
  localStorage.removeItem(VISITORS_CONTENT_STACK_DATA)
  //  访客上级手机号码
  localStorage.removeItem(VISITORS_UP_LEVEL_NUMBER)
}
export const userNameVerification = (str) => {
  let len = 0;
  let list = str?.split("");
  for (let i = 0; i < list.length; i++) {
    let s = list[i];
    if (s.match(/[\u0000-\u00ff]/g)) { //半角
      len += 1;
    } else if (s.match(/[\u4e00-\u9fa5]/g)) { //中文 
      len += 2;
    } else if (s.match(/[\uff00-\uffff]/g)) { //全角
      len += 2;
    }
  }
  if (len <= 48) {
    return true;
  } else {
    return false;
  }
};

// 获取浏览器 URL 全部参数
export const getUrlParameter = (url) => {
  if (!url.includes("?")) return ''
  let arr = url?.split('?')
  url = arr[1]
  return `?${url}`
}

//  获取浏览器 URL 全部参数 區分參數是否轉嗎
export const getUrlAllParameter = () => {
  try {
    if (typeof window == 'undefined' || typeof window == undefined) return;
    const url = location.href;
    if (!url.includes("?")) return ''
    let arr = url?.split('?')
    let query = arr.length > 0 && arr[1];
    let param = '';
    const conditionalEnumeration = hasUTMParams(query);
    if (query.includes("h=") && conditionalEnumeration) {
      //    當路徑參數中包含 h= 並且不包含 UTM 參數時
      param = atob(query?.split("=")[1])?.split('?')[1];
    } else {
      param = query;
    }
    return param;
  } catch (err) {
    console.log('========err=====', err);
    return ``
  }
}

//  获取浏览器 URL UTM 参数
export const getQueryUTMString = (prefix) => {
  try {
    if (typeof window == 'undefined' || typeof window == undefined) return '';
    let url = location?.href; // window.location.search
    if (!url.includes("?")) return ''
    let arr = url?.split('?')
    let query = arr.length > 0 && arr[1];
    let param = '';
    const urlSearchParams = new URLSearchParams(query)
    const result = Object.fromEntries(urlSearchParams.entries())
    //    當路徑參數中包含 h 
    if (result.h) {
      //  不转码之前是否包含 UTM 參數
      let noTranscoding = serializeUTMParams(result, UTM_PARAMS)
      if (noTranscoding && noTranscoding != '') {
        return `${prefix}${noTranscoding}`
      } else {
        if (result.h == '/cart') return ''
        let resultUrl = atob(result.h)
        const conditionalEnumeration = hasUTMParams(resultUrl)
        if (conditionalEnumeration) {
          let vars = resultUrl.includes("?") ? resultUrl.split('?')[1]?.split("&") : resultUrl?.split("&");
          for (let i = 0; i < vars?.length; i++) {
            let pair = vars[i]?.split("=");
            UTM_PARAMS.map((item) => {
              if (item == pair[0]) {
                param = `${param}&${vars[i]}`
              }
            })
          }
        } else return ''
      }
    } else {
      let vars = query?.split("&");
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i]?.split("=");
        UTM_PARAMS.map((item) => {
          if (item == pair[0]) {
            param = `${param}&${vars[i]}`
          }
        })
      }
    }
    if (prefix) {
      if (param.substring(1) !== '') {
        return `${prefix}${param.substring(1)}`
      } else {
        return ''
      }
    } else {
      return param.substring(1) ?? ''
    }
  } catch (err) {
    console.log('========err=====', err);
    return ``
  }
}
/**
 * 检查给定URL是否包含任何UTM参数
 * UTM参数用于跟踪营销活动的效果，常见的UTM参数包括utm_source、utm_medium、utm_campaign等
 * 此函数主要用于判断一个URL是否包含这些用于跟踪的UTM参数
 * 
 * @param {string} url - 待检查的URL字符串
 * @returns {boolean} - 如果URL包含任何UTM参数，则返回true；否则返回false
 */
export const hasUTMParams = (url) => {
  // 提取查询参数部分
  const queryString = url.split('?')[1] || '';
  // 创建URLSearchParams对象，用于查询字符串的解析
  const params = new URLSearchParams(queryString);

  // 检查是否有任意 UTM 参数存在
  return UTM_PARAMS.some(param => params.has(param));
}

/**
 * 将UTM参数序列化为查询字符串
 * 
 * 该函数的作用是将给定的对象中的UTM参数过滤并序列化为查询字符串形式
 * 它首先过滤出对象中与utmParams数组中的键名相匹配的项，然后将这些项
 * 转换为"key=value"的形式，并使用"&"符号连接起来，其中value会经过URL编码
 * 
 * @param {Object} result - 包含潜在UTM参数的对象
 * @param {Array} utmParams - UTM参数的数组，用于过滤result对象中的键
 * @returns {string} 序列化后的UTM参数查询字符串
 */
export const serializeUTMParams = (result, utmParams) => {
  // 过滤出result对象中与utmParams数组中的键名相匹配的项
  const filteredParams = Object.keys(result).filter(key => utmParams.includes(key));

  // 将过滤后的参数项转换为"key=value"的形式，并使用"&"符号连接起来
  const serializedParams = filteredParams.map(key => `${key}=${encodeURIComponent(result[key])}`).join('&');

  // 返回序列化后的查询字符串
  return serializedParams;
};

//  数组分组
export const arrayGroupBy = (array, key) => {
  return array.reduce((result, currentValue) => {
    (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
    return result;
  }, {})
}

//  根据浏览器缓存容器区分 批量修改、单一修改 SOP订单 signId 参数
export const getSignIds = (key) => {
  try {
    if (typeof window !== undefined && typeof window !== 'undefined') {
      const signId = JSON.parse(localStorage.getItem(key ? key : 'sopModify')).signId
      const signIds = localStorage.getItem('SOP_ORDER_SIGNID_LIST') ? JSON.parse(localStorage.getItem('SOP_ORDER_SIGNID_LIST')) : []
      return signIds.length > 0 ? signIds : [signId]
    }
  } catch (error) {
    console.log('【getSignIds】', error);
  }
}

// 跳轉錨點
export const scrollToAnchor = anchorName => {
  if (anchorName && typeof window !== undefined && typeof window !== 'undefined') {
    // 找到锚点
    let anchorElement = document.getElementById(anchorName);
    // 如果对应id的锚点存在，就跳转到锚点
    if (anchorElement) {
      window.scrollTo({
        top: anchorElement.offsetTop + 150,
        behavior: 'smooth',
      });
    }
  }
};


//  判断一个字符串是否需要使用 atob 解码
export const isBase64Encoded = (str) => {
  try {
    // 检查字符串是否仅包含 Base64 允许的字符，并且长度是 4 的倍数（或者长度差 1 或 2 且结尾是 '='）
    const base64Regex = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/;
    return base64Regex.test(str);
  } catch (error) {
    console.log('isBase64Encoded >> catch:', error);
  }
}

//  判断是否需要使用 atob 函数对字符串进行解码
export const tryBase64Decode = (str) => {
  try {
    const decoded = atob(str);
    console.log('Decoded string:', decoded);
    return true; // 字符串是 Base64 编码的
  } catch (e) {
    console.warn('Failed to decode string as Base64:', e);
    return false; // 字符串不是 Base64 编码的
  }
}

export const checkContainsString = (str) => {
  try {
    // 使用 includes 方法检查是否包含 'p='
    let containsP = str.includes('p=');
    // 如果包含 'p='，但为了确保它不是 'exp=' 的一部分，我们需要进一步检查
    if (containsP) {
      // 检查 'p=' 是否不是 'exp=' 的一部分
      // 我们可以通过查找 'p=' 前的字符来判断
      let positionOfP = str.indexOf('p=');
      let notPartOfExp = (positionOfP === 0 || str.charAt(positionOfP - 1) !== 'e') ||
        (positionOfP < str.length - 2 && str.substr(positionOfP - 2, 2) !== 'ex');
      if (notPartOfExp) {
        console.log("字符串中包含独立的 'p='");
        return true
      } else {
        console.log("'p=' 是 'exp=' 的一部分或不存在");
        return false
      }
    } else {
      console.log("字符串中不包含 'p='");
      return false
    }
  } catch (error) {
    return false
  }
}